import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M230.4 992c-64 0-115.2-51.2-115.2-115.2V544l-38.4 38.4c-6.4 6.4-19.2 12.8-32 12.8s-25.6-6.4-32-12.8C6.4 569.6 0 556.8 0 544c0-6.4 6.4-19.2 12.8-32L480 44.8c6.4-6.4 19.2-12.8 32-12.8s25.6 6.4 32 12.8L1011.2 512c6.4 12.8 12.8 25.6 12.8 32 0 12.8-6.4 25.6-12.8 32-6.4 6.4-19.2 12.8-32 12.8s-25.6-6.4-32-12.8L512 147.2 211.2 448v422.4c0 12.8 12.8 25.6 25.6 25.6H352V710.4c0-25.6 19.2-44.8 44.8-44.8h230.4c25.6 0 44.8 19.2 44.8 44.8s-19.2 44.8-44.8 44.8H441.6v185.6c0 25.6-19.2 44.8-44.8 44.8H230.4z m396.8 0c-25.6 0-44.8-19.2-44.8-44.8 0-25.6 19.2-44.8 44.8-44.8h160c12.8 0 25.6-12.8 25.6-25.6v-256c0-25.6 19.2-44.8 44.8-44.8 25.6 0 44.8 19.2 44.8 44.8v256c0 64-51.2 115.2-115.2 115.2h-160z\" p-id=\"12054\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 39